import { render, staticRenderFns } from "./ImportProduct.vue?vue&type=template&id=2159227c&scoped=true&"
import script from "./ImportProduct.vue?vue&type=script&lang=ts&"
export * from "./ImportProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ImportProduct.vue?vue&type=style&index=0&id=2159227c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159227c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VDialog,VFlex,VForm,VLayout,VProgressLinear,VSpacer,VSubheader})
